import React, { useMemo } from "react";

import { PROFIT_TYPE } from "./profitabilityProduct";
import TableFilter from "~/components/panel/panelActions/tableFilter";
import { useTranslation } from "react-i18next";

const ProfitSelect = ({
  setSelected,
  selected,
}: {
  setSelected: (value: string) => void;
  selected: string;
}) => {
  const { t } = useTranslation();
  const metricOptions = useMemo(
    () => [
      {
        value: PROFIT_TYPE.ProfitValue,
        label: t(`${PROFIT_TYPE.ProfitValue}`),
      },
      {
        value: PROFIT_TYPE.ProfitPercentage,
        label: t(`${PROFIT_TYPE.ProfitPercentage}`),
      },
    ],
    []
  );

  return (
    <TableFilter
      currentValue={selected}
      handleChange={setSelected}
      options={metricOptions}
      width="200px"
    />
  );
};

export default ProfitSelect;
